import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = [
    {
        path: '/',
        name: 'Index',
        redirect: '/home',
        component: () => import('@/view/home/index'),
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/view/home/home'),
                meta: {title: "首页"}
            },
            {
                path: '/product/number',
                name: 'ProductNumber',
                component: () => import('@/view/product/number'),
                meta: {title: "数显终端"}
            },
            {
                path: '/product/business',
                name: 'ProductBusiness',
                component: () => import('@/view/product/business'),
                meta: {title: "商显终端"}
            },
            {
                path: '/source/content',
                name: 'SourceContent',
                component: () => import('@/view/source/content'),
                meta: {title: "内容下载"}
            },
            {
                path: '/source/software',
                name: 'SourceSoftware',
                component: () => import('@/view/source/software'),
                meta: {title: "软件下载"}
            },
            {
                path: '/source/software/detail',
                name: 'SourceSoftwareDetail',
                component: () => import('@/view/source/software-detail'),
                meta: {title: "软件详情"}
            },


            {
                path: '/news/detail',
                name: 'NewsDetail',
                component: () => import('@/view/news/detail'),
                meta: {title: "新闻详情"}
            },
            {
                path: '/news/plan',
                name: 'NewsPlan',
                component: () => import('@/view/news/plan'),
                meta: {title: "解决方案"}
            },
            {
                path: '/news/share',
                name: 'NewsShare',
                component: () => import('@/view/news/share'),
                meta: {title: "案例分享"}
            },
            {
                path: '/news/center',
                name: 'NewsCenter',
                component: () => import('@/view/news/center'),
                meta: {title: "新闻中心"}
            },
            {
                path: '/about',
                name: 'About',
                component: () => import('@/view/about/index'),
                meta: {title: "关于我们"}
            },
        ]
    },
]

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({
        y: 0,
    }),
    routes,
})

router.beforeEach((to, from, next) => {
        if (to.meta.title) {
            document.title = to.meta.title
        } else {
            document.title = "维超"//没有就默认
        }
        next()
    }
)
export default router

